/* HeadingButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./HeadingButton.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { useIntl } from 'react-intl-next';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { formatShortcut, setNormalText, toggleHeading1, toggleHeading2, toggleHeading3, toggleHeading4, toggleHeading5, toggleHeading6 } from '@atlaskit/editor-common/keymaps';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { ToolbarDropdownItem, ToolbarKeyboardShortcutHint } from '@atlaskit/editor-toolbar';
import { Box } from '@atlaskit/primitives/compiled';
var headingSizeStylesMap = {
  normal: "_11c82smr",
  heading1: "_11c81c04",
  heading2: "_11c8nf1z",
  heading3: "_11c8lodh",
  heading4: "_11c8nbxd",
  heading5: "_11c8140y",
  heading6: "_11c81vhk"
};
var shortcuts = {
  normal: setNormalText,
  heading1: toggleHeading1,
  heading2: toggleHeading2,
  heading3: toggleHeading3,
  heading4: toggleHeading4,
  heading5: toggleHeading5,
  heading6: toggleHeading6
};
export var HeadingButton = function HeadingButton(_ref) {
  var blockType = _ref.blockType,
    api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var currentBlockType = useSharedPluginStateSelector(api, 'blockType.currentBlockType');
  var availableBlockTypesInDropdown = useSharedPluginStateSelector(api, 'blockType.availableBlockTypesInDropdown');
  if (!(availableBlockTypesInDropdown !== null && availableBlockTypesInDropdown !== void 0 && availableBlockTypesInDropdown.some(function (availableBlockType) {
    return availableBlockType.name === blockType.name;
  }))) {
    return null;
  }
  var fromBlockQuote = (currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name) === 'blockquote';
  var onClick = function onClick() {
    var _api$core, _api$blockType;
    api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$blockType = api.blockType) === null || _api$blockType === void 0 || (_api$blockType = _api$blockType.commands) === null || _api$blockType === void 0 ? void 0 : _api$blockType.setTextLevel(blockType.name, INPUT_METHOD.TOOLBAR, fromBlockQuote));
  };
  var shortcut = formatShortcut(shortcuts[blockType.name]);
  var isSelected = currentBlockType === blockType;
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    elemBefore: blockType.icon,
    elemAfter: shortcut ? /*#__PURE__*/React.createElement(ToolbarKeyboardShortcutHint, {
      shortcut: shortcut
    }) : undefined,
    onClick: onClick,
    isSelected: isSelected,
    ariaKeyshortcuts: shortcut
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: headingSizeStylesMap[blockType.name]
  }, formatMessage(blockType.title)));
};